import { ofType } from 'redux-observable';
import { of } from 'rxjs';
import { ajax } from 'rxjs/ajax';
import { mergeMap, switchMap } from 'rxjs/operators';

import {
  SignInFailure,
  SignInSuccess,
  termsAndConditionsFailure,
  termsAndConditionsSuccess,
} from '../../Redux/Actions/SignInAction';
import { SIGN_IN, TERMS_AND_CONDITIONS } from '../../Redux/Actiontype';
import { Basepath } from '../../config';

export const SignInEpic = action$ =>
  action$.pipe(
    ofType(SIGN_IN),
    switchMap(action =>
      ajax
        .post(`${Basepath}/api/admin/login`, action.payload, {
          // authentication:localStorage.getItem('sessionId')
        })
        .pipe(
          mergeMap(response => {
            if (response.response.statusCode === 200) {
              return of(SignInSuccess(response.response));
            } else {
              return of(SignInFailure(response.response));
            }
          }),
        ),
    ),
  );

export const TermsAndConditionsEpic = action$ =>
  action$.pipe(
    ofType(TERMS_AND_CONDITIONS),
    switchMap(action =>
      ajax.get(`${Basepath}/api/user/privacy_policy`, {}).pipe(
        mergeMap(response => {
          if (response.response.statusCode === 200) {
            return of(termsAndConditionsSuccess(response.response));
          } else {
            return of(termsAndConditionsFailure(response.response));
          }
        }),
      ),
    ),
  );
